<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container" style="margin-top:90px">
      <p>&zwnj;</p>

      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item active" aria-current="page">Online Events</li>
        </ol>
      </nav>
      <p>&zwnj;</p>

      <div>
        <div class="title_fontStyle  h2"><i class="fas fa-caret-right"></i> Online Events</div>
        <h5 class="mt-5">Continuously brings in trends, technologies, and issues discussed by industry experts.</h5>
        <p>&zwnj;</p>

        <div class="row text-center text-lg-left">
          <div class="col-lg-4 mb-4">
            <a href="https://bioasiataiwan.com/en/program/detail/35" target="_blank">
              <img
                src="../../assets/images/Event/Event1.jpg"
                class="EventBanner brightnessHover img-fluid "
                alt=""
                @click="SaveEvent_log1()"
              />
              <p class="EventTitle py-1">
                Check out all on-site programs in BIO Asia-Taiwan 2024 !
              </p>
            </a>
          </div>

          <div class="col-lg-4 mb-4">
            <a href="https://bioasiataiwan.com/en/registration/plan" target="_blank">
              <img
                src="../../assets/images/Event/Event2.jpg"
                class="EventBanner brightnessHover img-fluid "
                alt=""
                @click="SaveEvent_log2()"
              />
              <p class="EventTitle py-1">
                <!-- Take a look at 15 must-attend sessions! Register to join now! -->
                Join us in Innovation forum, Investment summit, Regional collaboration forum, Company presentations, and
                Satellite symposia.
              </p>
            </a>
          </div>

          <div class="col-lg-4 mb-4">
            <a href="https://bioasiataiwan.com/en/program/detail/37" target="_blank">
              <img
                src="../../assets/images/Event/Event3.jpg"
                class="EventBanner brightnessHover img-fluid "
                alt=""
                @click="SaveEvent_log3()"
              />
              <p class="EventTitle py-1">
                The 2024 Conference will frature 30 on-site sessions.
              </p>
            </a>
          </div>
          <div class="col-lg-4 mb-4">
            <a href="https://bioasiataiwan.com/en/program/detail/61" target="_blank">
              <img
                src="../../assets/images/Event/Event4.jpg"
                class="EventBanner brightnessHover img-fluid "
                alt=""
                @click="SaveEvent_log4()"
              />
              <p class=" EventTitle py-1">
                The 2024 Innovation Forum will showcase Taiwan's growing digital advantage and investment opportunities.
              </p>
            </a>
          </div>
          <div class="col-lg-4 mb-4">
            <a href="https://bioasiataiwan.com/en/program/detail/46" target="_blank">
              <img
                src="../../assets/images/Event/Event5.jpg"
                class="EventBanner brightnessHover img-fluid "
                alt=""
                @click="SaveEvent_log5()"
              />
              <p class=" EventTitle py-1">
                Maximize your visibility and ROI at BIO Asia-Taiwan 2024, let us tell you how you can benefit from
                Company Presentations!
              </p>
            </a>
          </div>
          <div class="col-lg-4 mb-4">
            <a href="https://expo.bioasiataiwan.com/en/visitorFloorplan.asp" target="_blank">
              <img
                src="../../assets/images/Event/Event6.jpg"
                class="EventBanner brightnessHover img-fluid "
                alt=""
                @click="SaveEvent_log6()"
              />
              <p class=" EventTitle py-1">
                Quick preview for onsite expo scale in July.
              </p>
            </a>
          </div>
          <!-- <div class="col-lg-4 mb-4">
            <a href="https://expo.bioasiataiwan.com/eventSeminar.asp" target="_blank">
              <img
                src="../../assets/images/Event_7.jpg"
                class="EventBanner brightnessHover img-fluid "
                alt=""
                @click="SaveEvent_log7()"
              />
              <p class=" EventTitle py-1">
                More than 30 exhibitors organize nearly 40 showcases and events, sharing industry knowledge and research results.
              </p>
            </a>
          </div> -->
        </div>
        <p>&zwnj;</p>
      </div>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        token: '',
        CSRF_Token: '',
      }
    },

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'exhcode']),
    },

    methods: {
      SaveEvent_log1() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent1 = `${NowPageUrl}#Schedule`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent1,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log2() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent2 = `${NowPageUrl}#conferenceOverview`
        // console.log(OpenEvent2)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent2,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log3() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent3 = `${NowPageUrl}#Registration`
        // console.log(OpenEvent3)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent3,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log4() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent4 = `${NowPageUrl}#conferenceAgenda`
        // console.log(OpenEvent4)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent4,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log5() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent5 = `${NowPageUrl}#presentations`
        // console.log(OpenEvent5)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent5,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log6() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent6 = `${NowPageUrl}#floorPlan`
        // console.log(OpenEvent6)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent6,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log7() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent7 = `${NowPageUrl}#Showcase`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent7,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log8() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent8 = `${NowPageUrl}#FloorPlan`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent8,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },
    },

    created() {
      const vm = this

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        vm.CSRF_Token = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      })
    },
  }
</script>

<style lang="scss" scoped>
  .EventBanner {
    transition: all 0.3s;
    background-size: cover;
    background-repeat: no-repeat;
    border: 1px solid gray;
    border-radius: 10px;
  }

  .EventTitle {
    font-size: 15px;
    line-height: 24px;
  }
</style>
